import { Link } from "react-router-dom";
import { ClientLayout } from "@/components/layout/ClientLayout";
import { X } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <ClientLayout>
      <div className="max-w-xl mx-auto pt-16 text-center" data-testid="payment-cancel-page">
        <X weight="bold" size={48} className="mx-auto text-[#ff2a00]" />
        <h1 className="font-display text-5xl mt-4">Payment cancelled</h1>
        <p className="text-[#a3a3a3] mt-2">No charges were made. You can try again anytime.</p>
        <Link to="/dashboard" className="btn-primary mt-8 inline-block px-6 py-3 text-sm font-bold uppercase tracking-wider">
          Back to dashboard
        </Link>
      </div>
    </ClientLayout>
  );
}
